import { render } from "@testing-library/react";
import React,{useState, useEffect} from "react";
import playIcon from "../images/Play.svg";
import pauseIcon from "../images/Pause.svg";
import pauseClickIcon from "../images/Pause-click.svg";
import playClickIcon from "../images/playblue.svg";
import ReactGA from "react-ga4";

const preloadSrcList = [
  playIcon,
  pauseIcon,
  pauseClickIcon,
  playClickIcon
]

export default function PlayItem(props){

    const [play, setPlay] = React.useState(false)

    const [clickMode, setClickMode ] = useState(false)

    useEffect(() => {
      preloadSrcList.forEach((image) => {
      new Image().src = image
      });
    }, []);

      
      const onMouseDownHandler = () => {
          setClickMode(true);
        // console.log("onMouseDown Event!");
      };

      const onMouseUpHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
      };

      const onMouseLeaveHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
      };
    // let pauseImg = clickMode?  pauseClickIcon : pauseIcon

    // let pauseClass = clickMode ?  "pause--icon" : "play--icon"

    
    function togglePlay(props) {
        setPlay(!play)
    }

    return(

        <div className="play-item"  onClick={() => {
            togglePlay();
            props.onClick();

            }}>
            {(props.playState == "pause"||props.playState == "init" ||props.playState == "buffering") ? <img 
                onClick={ReactGA.event({category: 'Engagement',action: "ui_play",value: 1})}
                onMouseDown={onMouseDownHandler}
                onMouseUp={onMouseUpHandler}
                onMouseLeave={onMouseLeaveHandler}
                onTouchMove={onMouseLeaveHandler}
                onTouchCancel={onMouseLeaveHandler}
                onTouchStart={onMouseDownHandler}
                onTouchEnd={onMouseUpHandler}
                src={(clickMode == true)? playClickIcon :playIcon}  
                className={(clickMode == true)? "pause-clicked-icon":"play--icon"}
                alt="" /> 
            : 
            <div>
                <img 
                    onClick={ReactGA.event({category: 'Engagement',action: "ui_pause",value: 1})}
                    onMouseDown={onMouseDownHandler}
                    onMouseUp={onMouseUpHandler}
                    onMouseLeave={onMouseLeaveHandler}
                    onTouchMove={onMouseLeaveHandler}
                    onTouchCancel={onMouseLeaveHandler}
                    onTouchStart={onMouseDownHandler}
                    onTouchEnd={onMouseUpHandler}
                    
                    src={(clickMode == true)? pauseClickIcon :pauseIcon}  
                    className={(clickMode == true)? "pause-clicked-icon":"play--icon"}
                    alt="" 

                />
            </div>
            }
        </div>
       
    )
}